import type { CockpitPeriodKey } from '../model/types'

const QUARTERS: CockpitPeriodKey[] = ['q1', 'q2', 'q3', 'q4']

export const getCockpitPeriodLabel = (periods: CockpitPeriodKey[]) => {
  if (periods.includes('fullYear')) {
    return 'Full Year'
  }

  if (periods.includes('ytd')) {
    return 'YTD'
  }

  /* Calendar order, so the order the quarters were picked in does not leak into the label. */
  return (
    QUARTERS.filter((quarter) => periods.includes(quarter))
      .map((quarter) => quarter.toUpperCase())
      .join(', ') || 'Full Year'
  )
}
